import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearAlerts } from "../../action/alert";

/**
 * Clears Redux alert/snackbar state when the route changes so errors from a
 * previous screen do not stay visible after navigation.
 * Mount once inside BrowserRouter (outside individual route pages).
 */
const NavigationAlertReset = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const prevPathnameRef = useRef(undefined);

  useEffect(() => {
    if (
      prevPathnameRef.current !== undefined &&
      prevPathnameRef.current !== location.pathname
    ) {
      dispatch(clearAlerts());
    }
    prevPathnameRef.current = location.pathname;
  }, [dispatch, location.pathname]);

  return null;
};

export default NavigationAlertReset;
